<template>
  <div class="scrollable only-y">
    <div class="page-header">
      <h1><i :class="'mdi mdi-' + $route.meta.icon"></i> {{ $route.name }}</h1>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">
          <i class="mdi mdi-home-outline"></i>
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.name }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="card-base card-shadow--medium p-10">
      <div class="random-inventory-container">
        <!-- Filtros y botón nuevo -->
        <el-row :gutter="20" class="mb-4">
          <!-- Filtros -->
          <el-col :xs="24" :sm="24" :md="16" :lg="18" class="mb-3">
            <el-form :inline="false" :model="filters" class="filter-form">
              <el-row :gutter="10">
                <el-col :xs="24" :sm="12" :md="6" :lg="5">
                  <el-form-item>
                    <el-input v-model="filters.consecutive" placeholder="Consecutivo" clearable />
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="12" :md="6" :lg="5">
                  <el-form-item>
                    <el-select v-model="filters.year" placeholder="Año" clearable style="width: 100%">
                      <el-option v-for="year in years" :key="year" :label="year" :value="year" />
                    </el-select>
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="12" :md="6" :lg="5">
                  <el-form-item>
                    <el-select v-model="filters.month" placeholder="Mes" clearable style="width: 100%">
                      <el-option v-for="month in months" :key="month.value" :label="month.label" :value="month.value" />
                    </el-select>
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="12" :md="6" :lg="5">
                  <el-form-item>
                    <el-select v-model="filters.status" placeholder="Estado" clearable style="width: 100%">
                      <el-option label="Pendiente" value="Pending" />
                      <el-option label="Completado" value="Completed" />
                    </el-select>
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="12" :md="6" :lg="4">
                  <el-form-item>
                    <el-button type="primary" icon="el-icon-search" style="width: 100%" @click="searchRecords">
                      Filtrar
                    </el-button>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-col>

          <!-- Botón nuevo -->
          <el-col :xs="24" :sm="24" :md="8" :lg="6" class="text-right">
            <el-button type="success" icon="el-icon-plus" @click="createNewInventory">
              Nuevo Inventario
            </el-button>
          </el-col>
        </el-row>

        <!-- Tabla -->
        <el-table v-loading="loading" :data="inventories" style="width: 100%">
          <el-table-column prop="consecutive" label="Consecutivo" width="120" />

          <el-table-column prop="requested_quantity" label="Cantidad Solicitada" width="100">
            <template slot="header" slot-scope="scope">
              <el-popover placement="top-start" title="Información" width="200" trigger="hover"
                content="Esta cantidad puede variar, ya que no todos los productos encontrados de manera aleatoria tendrán inventario.">
                <i class="el-icon-info" slot="reference" style="cursor: pointer;"></i>
              </el-popover>
              <span> Cantidad Solicitada</span>
            </template>
          </el-table-column>

          <el-table-column prop="details" label="Productos" width="130">
            <template slot="header" slot-scope="scope">
              <el-popover placement="top-start" title="Información" width="200" trigger="hover"
                content="Número total de productos obtenidos por bodegas. La cantidad puede ser mayor o menor, ya que un producto puede estar en mas de una bodega o no tener inventario.">
                <i class="el-icon-info" slot="reference" style="cursor: pointer;"></i>
              </el-popover>
              <span> Productos</span>
            </template>
            <template slot-scope="scope">
              <i class="mdi mdi-cart-arrow-down"></i> {{ formatNumber(scope.row.details.length) }}
            </template>
          </el-table-column>

          <el-table-column prop="created_by" label="Creado por">
            <template slot-scope="scope">
              {{ scope.row.creator ? scope.row.creator.name : "-" }}
            </template>
          </el-table-column>

          <el-table-column prop="inventory_year" label="Año" width="100" />

          <el-table-column prop="inventory_month" label="Mes" width="100">
            <template slot-scope="scope">
              {{ getMonthName(scope.row.inventory_month) }}
            </template>
          </el-table-column>

          <el-table-column prop="created_at" label="Creación" width="100">
            <template slot-scope="scope">
              <span v-html="formatDate(scope.row.created_at)"></span>
            </template>
          </el-table-column>

          <el-table-column prop="status" label="Estado" width="120">
            <template slot-scope="scope">
              <el-tag :type="scope.row.status === 'Pending' ? 'warning' : 'success'">
                {{ scope.row.status === "Pending" ? "Pendiente" : "Completado" }}
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column prop="uploaded_by" label="Subido por">
            <template slot-scope="scope">
              {{ scope.row.uploader ? scope.row.uploader.name : "-" }}
            </template>
          </el-table-column>

          <el-table-column prop="uploaded_to" label="Fecha subida" width="110">
            <template slot-scope="scope">
              <span v-html="scope.row.uploaded_to ? formatDate(scope.row.uploaded_to) : '-'"></span>
            </template>
          </el-table-column>

          <el-table-column label="Acciones" width="200" fixed="right">
            <template slot-scope="scope">
              <el-tooltip content="Descargar" placement="top">
                <el-button size="mini" icon="el-icon-download" @click="downloadInventoryCheck(scope.row)" circle>
                </el-button>
              </el-tooltip>

              <el-tooltip content="Subir archivo" placement="top">
                <el-button v-if="scope.row.status === 'Pending'" size="mini" type="primary" icon="el-icon-upload2"
                  @click="uploadInventory(scope.row)" circle>
                </el-button>
              </el-tooltip>

              <el-tooltip content="Eliminar" placement="top">
                <el-button v-if="scope.row.status !== 'Completed'" size="mini" type="danger" icon="el-icon-delete"
                  @click="deleteInventory(scope.row)" circle>
                </el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <div v-if="inventories.length > 0" class="pagination-box" style="text-align: end; padding-top: 10px">
          <el-pagination layout="total, prev, pager, next" :page-size="pageSize" :total="total_rows"
            @current-change="handleCurrentPage"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import {
  getAll as getRandomInventory,
  store as createRandomInventory,
  deleteData as deleteRandomInventory,
  inventoryDownload,
  uploadInventory,
  downloadInventoryCheck,
} from "@/api/randomInventory";
export default {
  name: "RandomInventory",
  data() {
    return {
      loading: false,
      formatFileDownload: "xlsx",
      inventories: [],
      filters: {
        consecutive: "",
        year: "",
        month: "",
        status: "",
      },
      years: this.generateYears(),
      months: [
        { value: 1, label: "Enero" },
        { value: 2, label: "Febrero" },
        { value: 3, label: "Marzo" },
        { value: 4, label: "Abril" },
        { value: 5, label: "Mayo" },
        { value: 6, label: "Junio" },
        { value: 7, label: "Julio" },
        { value: 8, label: "Agosto" },
        { value: 9, label: "Septiembre" },
        { value: 10, label: "Octubre" },
        { value: 11, label: "Noviembre" },
        { value: 12, label: "Diciembre" },
      ],
      // Paginación
      pageSize: 10,
      currentPage: 1,
      total_rows: 0,
    };
  },

  created() {
    this.fetchInventories();
  },

  methods: {
    formatNumber(number) {
      return number.toLocaleString("es-CO");
    },

    handleCurrentPage(page) {
      this.currentPage = page;
      this.fetchInventories();
    },

    generateYears() {
      const currentYear = new Date().getFullYear();
      const years = [];
      for (let i = currentYear - 5; i <= currentYear; i++) {
        years.push(i);
      }
      return years;
    },

    getMonthName(month) {
      // convertir a entero
      const monthInt = parseInt(month);
      const foundMonth = this.months.find((m) => m.value === monthInt);
      return foundMonth ? foundMonth.label : "-";
    },

    formatDate(date) {
      // separar fecha y hora con salto de linea
      var dateRegister = moment(date).format("DD/MM/YYYY HH:mm");
      const [datePart, timePart] = dateRegister.split(" ");
      return `${datePart} <br> ${timePart}`;
    },

    async fetchInventories() {
      try {
        this.loading = true;
        const response = await getRandomInventory(this.filters, this.pageSize, this.currentPage);
        this.inventories = response.data.data.data;
        this.total_rows = response.data.data.total;
      } catch (error) {
        this.$message.error("Error al cargar los inventarios");
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    searchRecords() {
      this.fetchInventories();
    },

    async createNewInventory() {
      try {
        const { value: quantity } = await this.$prompt(
          "Ingrese la cantidad de registros (Max: 1-5000)",
          "Nuevo Inventario",
          {
            confirmButtonText: "Crear",
            cancelButtonText: "Cancelar",
            inputType: "number",
            inputValue: 100,
            showClose: false,
            closeOnClickModal: false,
            closeOnPressEscape: false,
            inputPattern: /^([1-9]|[1-9][0-9]|[1-9][0-9][0-9]|[1-4][0-9][0-9][0-9]|5000)$/,
            inputErrorMessage: "Por favor ingrese una cantidad válida entre 1 y 5000",
            inputValidator: (value) => {
              if (!value) return "La cantidad es requerida";
              const num = parseInt(value);
              if (num < 1 || num > 5000) return "La cantidad debe estar entre 1 y 5000";
              return true;
            },
            beforeClose: (action, instance, done) => {
              if (action === "confirm") {
                const inputValue = instance.inputValue;
                if (!inputValue || inputValue < 1 || inputValue > 5000) {
                  this.$message.error("Por favor ingrese una cantidad válida entre 1 y 5000");
                  return false;
                }

                instance.confirmButtonLoading = true;
                instance.confirmButtonText = "Creando...";
                instance.showClose = false;
                instance.closeOnClickModal = false;
                instance.closeOnPressEscape = false;

                // Ejecutar la acción de forma asíncrona
                this.processInventoryCreation(instance, done, inputValue);
              } else {
                done();
              }
            },
          }
        );
      } catch (error) {
        if (error !== "cancel") {
          console.error("Dialog error:", error);
          this.$message({
            type: "info",
            message: "Operación cancelada",
          });
        }
      }
    },

    async processInventoryCreation(instance, done, quantity) {
      try {
        const response = await createRandomInventory(quantity);

        if (response.data && response.data.code === 200) {
          // descargar el inventario creado con la cantidad especificada
          var inventoryDetails = await this.downloadInventory(response.data.data, quantity);
          // validar errores del archivo descargado
          if (inventoryDetails && inventoryDetails.message) {
            instance.confirmButtonLoading = false;
            instance.confirmButtonText = "Crear";
            done();
            return;
          }

          this.$message.success("Inventario creado correctamente");
          await this.fetchInventories();
          instance.confirmButtonLoading = false;
          instance.confirmButtonText = "Crear";

          // Cerrar el diálogo
          done();
        } else {
          instance.confirmButtonLoading = false;
          instance.confirmButtonText = "Crear";
          this.$message.error("Error: " + (response.data?.error || "Error desconocido"));
        }
      } catch (error) {
        instance.confirmButtonLoading = false;
        instance.confirmButtonText = "Crear";
        console.error("Error creating inventory:", error);
        this.$message.error(
          "Error al crear el inventario: " + (error.message || "Error desconocido")
        );
      }
    },

    async downloadInventory(inventory, quantity) {
      try {
        const response = await inventoryDownload(quantity, {
          inventory_id: inventory.id,
          format: this.formatFileDownload,
        });

        var format =
          this.formatFileDownload === "csv"
            ? "text/csv"
            : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        const url = URL.createObjectURL(
          new Blob([response.data], {
            type: format,
          })
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          "Inventario_" + inventory.consecutive + "." + this.formatFileDownload
        );
        document.body.appendChild(link);
        link.click();
      } catch (error) {
        console.error(error);
        this.$message.error(
          "Error al descargar el inventario: " + (error.message || "Error desconocido")
        );
        return error;
      }
    },

    async uploadInventory(row) {
      const fileInput = document.createElement("input");
      fileInput.type = "file";
      fileInput.accept = ".csv,.xlsx";

      fileInput.onchange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        try {
          const formData = new FormData();
          formData.append("file", file);

          const response = await uploadInventory(row.id, formData);

          if (response.data.code === 200) {
            // si response.data.errors esta vacio mostrar mensaje de exito
            if (response.data.errors.length === 0) {
              this.$message.success("Archivo cargado correctamente");
              this.fetchInventories();
            } else {
              this.$alert(
                response.data.errors.slice(0, 10).join("<br>") +
                (response.data.errors.length > 3 ? "..." : ""),
                "Errores encontrados",
                {
                  confirmButtonText: "Aceptar",
                  confirmButtonClass: "el-button--danger",
                  dangerouslyUseHTMLString: true
                }
              );
            }
          } else {
            if (response.data.code === 400) {
              this.$alert(
                response.data.errors.slice(0, 10).join("<br>") +
                (response.data.errors.length > 3 ? "..." : ""),
                "Errores encontrados",
                {
                  confirmButtonText: "Aceptar",
                  confirmButtonClass: "el-button--danger",
                  dangerouslyUseHTMLString: true
                }
              );
            } else {
              this.$message.error(
                "Error: " +
                (response.data?.error[Object.keys(response.data.error)[0]] || "Error desconocido")
              );
            }
          }
        } catch (error) {
          this.$message.error("Error al cargar el archivo");
          console.error(error);
        }
      };

      fileInput.click();
    },

    async deleteInventory(row) {
      try {
        await this.$confirm("¿Está seguro de eliminar este inventario?", "Advertencia", {
          confirmButtonText: "Sí",
          cancelButtonText: "No",
          type: "warning",
        });

        const response = await deleteRandomInventory(row.id);
        // validar si el inventario fue eliminado correctamente
        if (response.data.code === 200) {
          this.$message.success("Inventario eliminado correctamente");
          this.fetchInventories();
        } else {
          this.$message.error("Error: " + response.data.error);
        }
      } catch (error) {
        if (error !== "cancel") {
          this.$message.error("Error al eliminar el inventario");
          console.error(error);
        }
      }
    },

    async downloadInventoryCheck(row) {
      try {
        // si row.status es Completed, genero el nombre del archivo
        const fileName =
          row.status === "Completed"
            ? "Revisión_Inventario_" + row.consecutive + ".xlsx"
            : "Toma_Inventario_" + row.consecutive + ".xlsx";

        const response = await downloadInventoryCheck(row.id);
        const url = URL.createObjectURL(
          new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          })
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
      } catch (error) {
        console.error(error);
        this.$message.error(
          "Error al descargar la revisión del inventario: " + (error.message || "Error desconocido")
        );
      }
    },
  },
};
</script>

<style lang="scss">
.el-popover {
  word-break: normal;
  overflow-y: hidden;
}
</style>
<style lang="css" scoped>
.random-inventory-container {
  padding: 20px;
}

.mb-4 {
  margin-bottom: 1.5rem;
}

.mb-3 {
  margin-bottom: 1rem;
}

.text-right {
  text-align: right;
}

.filter-form .el-form-item {
  margin-bottom: 10px;
}

@media (max-width: 768px) {
  .text-right {
    text-align: left;
    margin-top: 1rem;
  }
}

.dialog-content {
  padding: 20px;

  h3 {
    margin-bottom: 20px;
    font-size: 18px;
  }

  .form-item {
    margin-bottom: 15px;

    label {
      display: block;
      margin-bottom: 8px;
      font-weight: bold;
    }

    .el-input__inner {
      width: 100%;
      padding: 8px;
      border: 1px solid #dcdfe6;
      border-radius: 4px;

      &:focus {
        border-color: #409eff;
        outline: none;
      }
    }
  }
}

.custom-dialog {
  .el-message-box__content {
    padding: 0;
  }
}
</style>
